<button
  class="copy-quote-selections-button"
  [class.copy-quote-selections-button--disabled]="!valid()"
  [disabled]="!valid()"
  [attr.aria-disabled]="!valid()"
  [pTooltip]="tooltipText()"
  [tooltipDisabled]="!valid()"
  tooltipPosition="bottom"
  tooltipStyleClass="quote-tool-lite__copy-quote-selections-tooltip"
  (click)="copyToClipboard()"
  (mouseleave)="onMouseLeave()"
  data-qa="copy-quote-selections-button"
>
  <img ngSrc="/assets/images/copy-selection-icon.svg" width="38" height="38" alt="Copy selections" />
</button>
